import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { DollarSign, Users, TrendingUp, ArrowRight, Check, Handshake } from "lucide-react";

const Affiliation = () => {
  const benefits = [
    "30% de commission récurrente sur chaque vente",
    "Cookie de suivi 90 jours",
    "Dashboard de suivi en temps réel",
    "Matériels marketing fournis (bannières, emails)",
    "Paiement mensuel via PayPal ou virement",
    "Support dédié aux affiliés",
  ];

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-24">
        <section className="section-padding relative overflow-hidden">
          <div className="absolute inset-0 hero-glow" />
          <div className="container-custom relative z-10">
            <div className="text-center max-w-4xl mx-auto">
              <span className="text-sm font-semibold text-emerald-400 uppercase tracking-wider mb-4 block flex items-center justify-center gap-2">
                <Handshake className="w-4 h-4" />
                Programme d'Affiliation
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
                Gagnez de l'argent avec{" "}
                <span className="text-emerald-400">ThumbGenius</span>
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10">
                Recommandez ThumbGenius à votre audience et touchez 30% de commission récurrente sur chaque abonnement.
              </p>

              <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto mb-12">
                {[
                  { icon: Users, value: "500+", label: "Affiliés actifs" },
                  { icon: DollarSign, value: "$50K+", label: "Commissions versées" },
                  { icon: TrendingUp, value: "30%", label: "Commission récurrente" },
                ].map((stat, i) => (
                  <div key={i} className="p-6 rounded-xl bg-card border border-emerald-500/20">
                    <stat.icon className="w-8 h-8 text-emerald-400 mx-auto mb-3" />
                    <p className="text-3xl font-bold text-emerald-400">{stat.value}</p>
                    <p className="text-sm text-muted-foreground">{stat.label}</p>
                  </div>
                ))}
              </div>

              <div className="max-w-lg mx-auto text-left p-6 rounded-xl bg-card border border-emerald-500/20 mb-10">
                <h3 className="font-semibold text-lg mb-4 text-emerald-400">Avantages du programme</h3>
                <ul className="space-y-3">
                  {benefits.map((b, i) => (
                    <li key={i} className="flex items-start gap-3 text-sm">
                      <Check className="w-4 h-4 text-emerald-400 mt-0.5 shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <Link to="/signup">
                <Button variant="hero" size="xl" className="bg-gradient-to-r from-emerald-600 to-emerald-400 border-0">
                  Rejoindre le programme
                  <ArrowRight className="w-5 h-5" />
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Affiliation;
